<template>
    <div>
        {{ displayValue }}
    </div>
</template>

<script>
export default {
    computed: {
        displayValue: function () {
            if (this.value == 1) {
                return this.$t('messages.yes');
            }
            if (this.value == 0) {
                return this.$t('messages.No');
            }

            return this.$t('messages.n/a');
        },
    },
    props: {
        value: {
            required: true,
        },
    },
};
</script>
